import React from "react";
import { Send, Loader2 } from "lucide-react";

export default function ChatInput({
  inputMessage,
  setInputMessage,
  handleSubmit,
  handleKeyPress,
  isLoading,
  deepThinking,
  setDeepThinking,
}) {
  const toggleDeepThinking = () => {
    setDeepThinking((prev) => !prev);
  };

  return (
    <div className="border-gray-200 bg-white p-4">
      <form onSubmit={handleSubmit} className="flex gap-2">
        <input
          type="text"
          value={inputMessage}
          onChange={(e) => setInputMessage(e.target.value)}
          onKeyDown={handleKeyPress}
          placeholder="Ask me about SAP documentation or anything else..."
          className="flex-1 w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-700 h-15 text-lg resize-none"
          disabled={isLoading}
        />
        <button
          type="submit"
          className="p-3 bg-[#003366] text-white rounded-lg hover:bg-[#003366] focus:ring-2 focus:ring-blue-700 disabled:opacity-50"
          disabled={isLoading || !inputMessage.trim()}
        >
          {isLoading ? (
            <Loader2 className="w-6 h-6 animate-spin" />
          ) : (
            <Send className="w-6 h-6" />
          )}
        </button>
      </form>

      {/* Deep Thinking Toggle */}
      <div className="mt-3">
        <button
          type="button"
          onClick={toggleDeepThinking}
          className={`px-4 py-2 rounded-md text-white transition-colors duration-200 ${
            deepThinking
              ? "bg-green-600 hover:bg-green-700"
              : "bg-gray-400 hover:bg-gray-500"
          }`}
        >
          {deepThinking ? "🧠 Deep Thinking: ON" : "🧠 Deep Thinking: OFF"}
        </button>
      </div>
    </div>
  );
}
